import colors from '@theme/colors';
import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  dropDownStyles: {
    alignItems: 'center',
    borderColor: colors.neutral.darkMist,
    borderRadius: 8,
    borderWidth: 1,
    flexDirection: 'row',
    paddingHorizontal: 16,
    paddingVertical: 13,
  },
  modalBackdrop: {
    backgroundColor: colors.overlay.backdrop,
    flex: 1,
    justifyContent: 'flex-end',
  },
  modalCloseButton: {
    padding: 10,
  },
  modalContent: {
    backgroundColor: colors.neutral.cotton,
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    maxHeight: '80%',
    minHeight: '50%',
  },
  modalContentContainer: {
    padding: 20,
  },
  modalHeaderContainer: {
    borderBottomColor: colors.neutral.mist,
    borderBottomWidth: 1,
    padding: 20,
  },
  modalHeaderRow: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
});
export default styles;
